module.exports = __webpack_public_path__ + "img/crm.cf6b1c03.svg";